import { Input } from '@bitcine/cinesend-theme'
import capitalize from '../../helpers/capitalize'
import { Lock } from '../icons'

const Type = ({ field }) => {
  return (
    <Input
      label={{
        text: 'Field type',
        icon: { icon: Lock },
      }}
      value={capitalize(field.field_type)}
      disabled
    />
  )
}

export default Type
